import { OrderFields } from "../../../constants";
import type { TAddressRequestParams, TNewAddressForm } from "../types";

const mapNewAddressToRequestParams = (address: TNewAddressForm, isLocker: boolean): TAddressRequestParams => ({
  contactName: address[OrderFields.NEW_ADDRESS_NAME],
  contactEmail: address[OrderFields.NEW_ADDRESS_EMAIL],
  contactPhone: address[OrderFields.NEW_ADDRESS_PHONE],
  ...(isLocker
    ? {
        lockerId: address[OrderFields.NEW_ADDRESS_LOCKER] || "",
      }
    : {
        countryCode: address[OrderFields.DESTINATION_COUNTRY] || "",
        street: address[OrderFields.NEW_ADDRESS_STREET] || "",
        streetNumber: address[OrderFields.NEW_ADDRESS_HOUSE_NO] || "",
        flatNo: address[OrderFields.NEW_ADDRESS_FLAT_NO] || "",
        city: address[OrderFields.NEW_ADDRESS_CITY] || "",
        zip: address[OrderFields.NEW_ADDRESS_ZIP_CODE] || "",
      }),
});
export default mapNewAddressToRequestParams;
